import { useTranslation } from 'react-i18next';

export type AccountProfileTabKey = 'overview' | 'permissions' | 'audit';

export interface AccountProfileTabsProps {
    active: AccountProfileTabKey;
    onSelect: (tab: AccountProfileTabKey) => void;
    placementCount: number;
    auditCount?: number;
    showAuditTab?: boolean;
}

/**
 * EAA-1820 (frame 72): sub-tabs on `/console/accounts/:sub` — Tổng quan,
 * Quyền theo đơn vị, Nhật ký. Count badges mirror the handoff mock.
 */
export function AccountProfileTabs({
    active,
    onSelect,
    placementCount,
    auditCount,
    showAuditTab = true,
}: AccountProfileTabsProps) {
    const { t } = useTranslation();

    const tabs: { key: AccountProfileTabKey; label: string; count?: number }[] = [
        { key: 'overview', label: t('console.accounts.profile.tabs.overview') },
        {
            key: 'permissions',
            label: t('console.accounts.profile.tabs.permissions'),
            count: placementCount,
        },
    ];
    if (showAuditTab) {
        tabs.push({
            key: 'audit',
            label: t('console.accounts.profile.tabs.audit'),
            count: auditCount,
        });
    }

    return (
        <div className="acc-profile-tabs" role="tablist" aria-label={t('console.accounts.profile.tabsAria')}>
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={active === tab.key}
                    className={'acc-profile-tab' + (active === tab.key ? ' acc-profile-tab--on' : '')}
                    onClick={() => onSelect(tab.key)}
                >
                    {tab.label}
                    {typeof tab.count === 'number' && (
                        <span className="acc-profile-tab-count">{tab.count}</span>
                    )}
                </button>
            ))}
        </div>
    );
}

export default AccountProfileTabs;
